var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 26,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 26,
    stroke: "#C9C9C9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6611 8.3877H22.3392V18.5902H16.6611V8.3877Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0215 13.4893C17.0215 11.4163 17.9948 9.57767 19.4909 8.38794C18.3914 7.52273 17.0035 7 15.4893 7C11.9021 7 9 9.90209 9 13.4893C9 17.0763 11.9021 19.9785 15.4893 19.9785C17.0034 19.9785 18.3913 19.4558 19.4909 18.5905C17.9948 17.4188 17.0215 15.5622 17.0215 13.4893Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 13.4893C29.9997 17.0763 27.0976 19.9785 23.5104 19.9785C21.9963 19.9785 20.6084 19.4558 19.5088 18.5905C21.0229 17.4008 21.9783 15.5622 21.9783 13.4893C21.9783 11.4163 21.0049 9.57767 19.5088 8.38794C20.6083 7.52273 21.9963 7 23.5104 7C27.0976 7 29.9997 9.92016 29.9997 13.4893Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master-card.c1538a34280ef6470454a2af6495ca45.svg";
export { ForwardRef as ReactComponent };